import React, { useState } from "react";
import "../../index.css";
import "../../App.css";
import { Row, Radio, Typography } from "antd";
import { painEntryFormConstants } from "../../helpers/painEntryFormConstants";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "./../../redux-toolkit/store/store";
import { handleChangeReliefEffectiveness } from "../../redux-toolkit/slices/painEntryFormSlice";

const TePainReliefEffectiveness = () => {
  const dispatch = useDispatch();
  const reliefEffectiveness = useSelector(
    (state: RootState) => state.painEntryForm.reliefEffectiveness
  );
  const handleSelect = (value: string) => {
    dispatch(handleChangeReliefEffectiveness(value));
  };

  return (
    <div className="flex flex-col gap-2">
      <label className="h6 text-theme-text-secondary">
        <strong>Pain relief effectiveness *</strong>
      </label>
      <p className="body1 text-theme-text-primary mb-4">
        This will help you identify trends in what does and what doesn't help your pain.
      </p>
      <Radio.Group
        onChange={(e) => handleSelect(e.target.value)}
        value={reliefEffectiveness}
      >
        {painEntryFormConstants.reliefEffectiveness.map(
          ({ label, value }) => {
            return (
              <Radio key={`${label}_${value}`} value={value}>
                {label}
              </Radio>
            );
          }
        )}
      </Radio.Group>
    </div>
  );
};

export default TePainReliefEffectiveness;
